// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__eDCrz","container__input":"styles_container__input__lUk6R","skeleton-animation":"styles_skeleton-animation__VKE0e"};